/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Hours_BodyInputs */

const en_start_page_hours_body = /** @type {(inputs: Start_Page_Hours_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you work, where, and what you offer. The schedule makes sure nobody books the same hour twice.`)
};

const pl_start_page_hours_body = /** @type {(inputs: Start_Page_Hours_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiedy pracujesz, gdzie i co oferujesz. Grafik sam pilnuje, żeby nikt nie zarezerwował tej samej godziny dwa razy.`)
};

/**
* | output |
* | --- |
* | "When you work, where, and what you offer. The schedule makes sure nobody books the same hour twice." |
*
* @param {Start_Page_Hours_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_hours_body = /** @type {((inputs?: Start_Page_Hours_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Hours_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_hours_body(inputs)
	return en_start_page_hours_body(inputs)
});